// Generated by BUCKLESCRIPT VERSION 2.2.0, PLEASE EDIT WITH CARE
'use strict';

var Block = require("bs-platform/lib/js/block.js");
var Curry = require("bs-platform/lib/js/curry.js");
var Model = require("./model");
var React = require("react");
var Apollo = require("./apollo");
var MaterialUI = require("bs-material-ui/lib/js/src/MaterialUI.js");
var ReasonReact = require("reason-react/lib/js/src/ReasonReact.js");
var UrlResolve = require("url-resolve");
var Shallowequal = require("shallowequal");
var Configuration = require("./configuration");
var DiscussionQuery = require("./discussionQuery");
var OrdreDuJourQuery = require("./ordreDuJourQuery");

function pathToPage(path, hash) {
  if (path) {
    if (path[0] === "discussions") {
      var match = path[1];
      if (match) {
        var match$1 = match[1];
        if (match$1) {
          var match$2 = match$1[1];
          var legislature = match$1[0];
          var organe = match[0];
          if (match$2) {
            var match$3 = match$2[1];
            var bibard = match$2[0];
            if (match$3) {
              return /* DiscussionPage */Block.__(0, [
                        organe,
                        legislature,
                        bibard,
                        match$3[0],
                        match$3[1],
                        hash
                      ]);
            } else {
              return /* DiscussionPage */Block.__(0, [
                        organe,
                        legislature,
                        bibard,
                        "",
                        /* [] */0,
                        hash
                      ]);
            }
          } else {
            return /* OrganePage */Block.__(2, [
                      organe,
                      legislature
                    ]);
          }
        } else {
          return /* NotFoundPage */Block.__(1, [path]);
        }
      } else {
        return /* NotFoundPage */Block.__(1, [path]);
      }
    } else {
      return /* NotFoundPage */Block.__(1, [path]);
    }
  } else {
    return /* HomePage */0;
  }
}

var component = ReasonReact.reducerComponent("GraphqlClientQuery");

function make(hash, path, _) {
  var newrecord = component.slice();
  newrecord[/* willReceiveProps */3] = (function (param) {
      var state = param[/* state */2];
      var page = pathToPage(path, hash);
      if (Shallowequal(page, state[/* page */1])) {
        return state;
      } else {
        return /* record */[
                /* graphqlClient */state[/* graphqlClient */0],
                /* page */page
              ];
      }
    });
  newrecord[/* render */9] = (function (self) {
      var match = self[/* state */2][/* graphqlClient */0];
      if (match) {
        var graphqlClient = match[0];
        var match$1 = self[/* state */2][/* page */1];
        if (typeof match$1 === "number") {
          ReasonReact.Router[/* push */0]("/discussions/AN/15/592//tout");
          return React.createElement("div", undefined, ReasonReact.element(/* None */0, /* None */0, MaterialUI.AppBar[/* make */0](/* Some */["static"], /* None */0, /* None */0, /* None */0, /* None */0, /* array */[ReasonReact.element(/* None */0, /* None */0, MaterialUI.Toolbar[/* make */0](/* None */0, /* None */0, /* None */0, /* None */0, /* array */[ReasonReact.element(/* None */0, /* None */0, MaterialUI.Typography[/* make */3](/* None */0, /* None */0, /* None */0, /* None */0, /* Some */[/* Inherit */1], /* None */0, /* None */0, /* None */0, /* None */0, /* None */0, /* Some */[/* Title */5], /* array */[Model.ste(Configuration.config[/* appTitle */1])]))]))])), ReasonReact.element(/* None */0, /* None */0, MaterialUI.LinearProgress[/* make */0](/* None */0, /* None */0, /* None */0, /* None */0, /* None */0, /* None */0, /* array */[])));
        } else {
          switch (match$1.tag | 0) {
            case 0 : 
                return ReasonReact.element(/* None */0, /* None */0, DiscussionQuery.make(match$1[2], match$1[3], graphqlClient, match$1[5], match$1[1], match$1[0], match$1[4], /* array */[]));
            case 1 : 
                return React.createElement("div", undefined, ReasonReact.element(/* None */0, /* None */0, MaterialUI.AppBar[/* make */0](/* Some */["static"], /* None */0, /* None */0, /* None */0, /* None */0, /* array */[ReasonReact.element(/* None */0, /* None */0, MaterialUI.Toolbar[/* make */0](/* None */0, /* None */0, /* None */0, /* None */0, /* array */[ReasonReact.element(/* None */0, /* None */0, MaterialUI.Typography[/* make */3](/* None */0, /* None */0, /* None */0, /* None */0, /* Some */[/* Inherit */1], /* None */0, /* None */0, /* None */0, /* None */0, /* None */0, /* Some */[/* Title */5], /* array */[Model.ste(Configuration.config[/* appTitle */1])]))]))])), React.createElement("p", undefined, Model.ste("Page not foud!")));
            case 2 : 
                return ReasonReact.element(/* None */0, /* None */0, OrdreDuJourQuery.make(graphqlClient, match$1[1], match$1[0], /* array */[]));
            
          }
        }
      } else {
        return React.createElement("div", undefined, ReasonReact.element(/* None */0, /* None */0, MaterialUI.AppBar[/* make */0](/* Some */["static"], /* None */0, /* None */0, /* None */0, /* None */0, /* array */[ReasonReact.element(/* None */0, /* None */0, MaterialUI.Toolbar[/* make */0](/* None */0, /* None */0, /* None */0, /* None */0, /* array */[ReasonReact.element(/* None */0, /* None */0, MaterialUI.Typography[/* make */3](/* None */0, /* None */0, /* None */0, /* None */0, /* Some */[/* Inherit */1], /* None */0, /* None */0, /* None */0, /* None */0, /* None */0, /* Some */[/* Title */5], /* array */[Model.ste(Configuration.config[/* appTitle */1])]))]))])), ReasonReact.element(/* None */0, /* None */0, MaterialUI.LinearProgress[/* make */0](/* None */0, /* None */0, /* None */0, /* None */0, /* None */0, /* None */0, /* array */[])));
      }
    });
  newrecord[/* initialState */10] = (function () {
      return /* record */[
              /* graphqlClient : None */0,
              /* page */pathToPage(path, hash)
            ];
    });
  newrecord[/* reducer */12] = (function (action, state) {
      return /* Update */Block.__(0, [/* record */[
                  /* graphqlClient : Some */[action[0]],
                  /* page */state[/* page */1]
                ]]);
    });
  newrecord[/* subscriptions */13] = (function (self) {
      return /* :: */[
              /* Sub */[
                (function () {
                    var graphqlClient = Curry._2(Apollo.createGraphqlClient, UrlResolve(Configuration.config[/* apiUrl */0], "/graphql"), "ws" + UrlResolve(Configuration.config[/* apiUrl */0], "/subscriptions").slice(4));
                    Curry._1(self[/* send */4], /* GotGraphqlClient */[graphqlClient]);
                    return graphqlClient;
                  }),
                Apollo.deleteGraphqlClient
              ],
              /* [] */0
            ];
    });
  return newrecord;
}

exports.pathToPage = pathToPage;
exports.component = component;
exports.make = make;
/* component Not a pure module */



//////////////////
// WEBPACK FOOTER
// ./src/graphqlClientQuery.re
// module id = 1558
// module chunks = 0